import React, { useState } from "react";
import { authService } from "../services/authService";

function Login({ onLoginSuccess, onSwitchToSignup }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const result = await authService.login(email, password);

    if (result.success) {
      onLoginSuccess(result);
    } else {
      setError(result.message || "Login failed");
    }

    setLoading(false);
  };

  return (
    <div className="login-form">
      <form onSubmit={handleLogin} className="login-form-fields">
        <div className="login-field">
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
          />
        </div>

        <div className="login-field">
          <label htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
          />
        </div>

        {error && <div className="login-error">{error}</div>}

        <button
          type="submit"
          disabled={loading}
          className="login-submit"
          style={{
            opacity: loading ? 0.6 : 1,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      <p className="login-switch-text">
        Don't have an account?{" "}
        <button onClick={onSwitchToSignup} className="login-switch-link">
          Sign up here
        </button>
      </p>
    </div>
  );
}

export default Login;
